/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.purchases.init());

App.purchases = {
  init() {
    return $(document)
      .off("click", ".js-purchases-accounts-toggle", this.toggle_accounts)
      .on("click", ".js-purchases-accounts-toggle", this.toggle_accounts);
  },


  toggle_accounts(evt) {
    evt.preventDefault();
    return $(".js-purchases-accounts-list").toggleClass("active");
  }
};
